

  const openBtn = document.getElementById("openPopup");
  const modal = document.getElementById("popupModal");
  const closeBtn = document.querySelector(".popup-close");

  openBtn.addEventListener("click", function(e) {
    e.preventDefault();
    modal.classList.add("active");
  });

  closeBtn.addEventListener("click", function() {
    modal.classList.remove("active");
  });

  modal.addEventListener("click", function(e) {
    if (e.target === modal) {
      modal.classList.remove("active");
    }
  });